import React, { useCallback, useMemo } from 'react'
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { isMainUser } from '@verzekeringapp-mono/shared/src/utils/resource_utils'
import { IResourceAuthorization } from '@verzekeringapp-mono/shared/src/models/resource_authorization'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'

const style = (resourceAuthorization: IResourceAuthorization, mainUser: boolean) => {
  if (mainUser) return 'cursor-pointer border-border-subtle bg-surface-card hover:shadow-md'
  if (resourceAuthorization.active) return 'cursor-default border-status-success-strong bg-status-success-subtle'

  return 'border-border-danger bg-status-danger-subtle'
}
const UserCard = (resourceAuthorization: IResourceAuthorization) => {
  const mainUser = useMemo(() => isMainUser(resourceAuthorization?.roles), [resourceAuthorization?.roles])
  const { id, userEmail } = resourceAuthorization
  const { deleteResourceAuthorization } = useResourceAuthorization()

  const deleteRelationUser = useCallback(() => {
    if (mainUser) {
      return
    }

    deleteResourceAuthorization(resourceAuthorization.id).then(() => {
      window.location.reload()
    })
  }, [mainUser, id])

  return (
    <Link
      to={mainUser ? '/mijn-profiel/gegevens-wijzigen' : '#'}
      key={id}
      className={`mt-4 flex flex-wrap items-center justify-between rounded-md border p-4 ${style(
        resourceAuthorization,
        mainUser
      )}`}
    >
      <div>
        <p className='font-semibold'>
          {mainUser ? 'Hoofdgebruiker' : 'Subgebruiker'}
        </p>

        <p>{userEmail}</p>

        <p>{resourceAuthorization.name}</p>

        <p>{resourceAuthorization.combiNumber}</p>
      </div>

      <div>
        {mainUser
          ? (
            <div className='text-icon-muted hover:text-status-warning-foreground'>
              <FontAwesomeIcon
                icon={faPencil}
                size='lg'
              />
            </div>
          )
          : (
            <div className='flex gap-4'>
              <button
                type='button'
                className='text-icon-muted hover:text-status-danger-foreground'
                onClick={e => {
                  e.preventDefault()
                  const isConfirmed = confirm(
                    'Weet je zeker dat je deze gebruiker wilt verwijderen?'
                  )

                  if (isConfirmed) {
                    deleteRelationUser()
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  size='lg'
                />
              </button>
            </div>
          )}
      </div>
    </Link>
  )
}

export default UserCard
